import httpClient from "../httpClient";
import { API_COMORBIDITY_UPDATE } from "../config";

const updateComorbidityInfo = {
    updateInfo: (id, data) => httpClient.post(API_COMORBIDITY_UPDATE + '/' + id, data),
};

export default updateComorbidityInfo;
